import { render, staticRenderFns } from "./ServiceRequest.vue?vue&type=template&id=f842b6a4&scoped=true&"
import script from "./ServiceRequest.vue?vue&type=script&lang=js&"
export * from "./ServiceRequest.vue?vue&type=script&lang=js&"
import style0 from "./ServiceRequest.vue?vue&type=style&index=0&id=f842b6a4&prod&scoped=true&lang=css&"
import style1 from "./ServiceRequest.vue?vue&type=style&index=1&id=f842b6a4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f842b6a4",
  null
  
)

export default component.exports